import { render } from "./uploadunitswithtenants.vue?vue&type=template&id=ab8c0b88&scoped=true"
import script from "./uploadunitswithtenants.vue?vue&type=script&lang=js"
export * from "./uploadunitswithtenants.vue?vue&type=script&lang=js"

import "./uploadunitswithtenants.vue?vue&type=style&index=0&id=ab8c0b88&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab8c0b88"]])

export default __exports__